// src/pages/conocimiento/components/ArticuloFiltros.tsx
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
  Button,
} from '@/components/ui';
import { X } from 'lucide-react';
import {
  TIPO_ARTICULO_LABELS,
  AMBITO_ARTICULO_LABELS,
  ESTADO_ARTICULO_LABELS,
} from '@/types';
import type { ArticuloFiltros as FiltrosType, TipoArticulo, AmbitoArticulo, EstadoArticulo } from '@/types';

interface ArticuloFiltrosProps {
  filtros: FiltrosType;
  onChange: (filtros: FiltrosType) => void;
}

const tipoOptions = [
  { value: '_all_', label: 'Todos los tipos' },
  ...Object.entries(TIPO_ARTICULO_LABELS).map(([value, label]) => ({
    value,
    label,
  })),
];

const ambitoOptions = [
  { value: '_all_', label: 'Todos los ámbitos' },
  ...Object.entries(AMBITO_ARTICULO_LABELS).map(([value, label]) => ({
    value,
    label,
  })),
];

const estadoOptions = [
  { value: '_all_', label: 'Todos los estados' },
  ...Object.entries(ESTADO_ARTICULO_LABELS).map(([value, label]) => ({
    value,
    label,
  })),
];

export function ArticuloFiltros({ filtros, onChange }: ArticuloFiltrosProps) {
  const hasFilters = filtros.tipo || filtros.ambito || filtros.estado;

  const clearFilters = () => {
    onChange({});
  };

  return (
    <div className="flex items-center gap-4 flex-wrap">
      <Select
        value={filtros.tipo || '_all_'}
        onValueChange={(value) =>
          onChange({
            ...filtros,
            tipo: value === '_all_' ? undefined : (value as TipoArticulo),
          })
        }
      >
        <SelectTrigger className="w-40">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {tipoOptions.map((opt) => (
            <SelectItem key={opt.value} value={opt.value}>
              {opt.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <Select
        value={filtros.ambito || '_all_'}
        onValueChange={(value) =>
          onChange({
            ...filtros,
            ambito: value === '_all_' ? undefined : (value as AmbitoArticulo),
          })
        }
      >
        <SelectTrigger className="w-44">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {ambitoOptions.map((opt) => (
            <SelectItem key={opt.value} value={opt.value}>
              {opt.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <Select
        value={filtros.estado || '_all_'}
        onValueChange={(value) =>
          onChange({
            ...filtros,
            estado: value === '_all_' ? undefined : (value as EstadoArticulo),
          })
        }
      >
        <SelectTrigger className="w-40">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {estadoOptions.map((opt) => (
            <SelectItem key={opt.value} value={opt.value}>
              {opt.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      {hasFilters && (
        <Button variant="ghost" size="sm" onClick={clearFilters}>
          <X className="h-4 w-4 mr-1" />
          Limpiar
        </Button>
      )}
    </div>
  );
}
